import { render, staticRenderFns } from "./Governances.vue?vue&type=template&id=584f8f25&scoped=true&"
import script from "./Governances.vue?vue&type=script&lang=js&"
export * from "./Governances.vue?vue&type=script&lang=js&"
import style0 from "./Governances.vue?vue&type=style&index=0&id=584f8f25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f8f25",
  null
  
)

export default component.exports